(function () {
  var STD_W = 1650;
  var STD_H = 2200;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function gcd(a, b) {
    a = Math.abs(a | 0);
    b = Math.abs(b | 0);
    while (b) {
      var t = b;
      b = a % b;
      a = t;
    }
    return a || 1;
  }

  function ratioParts(w, h) {
    var g = gcd(w, h);
    return [w / g, h / g];
  }

  function ratioLabel(w, h) {
    if (!w || !h) return '—';
    var parts = ratioParts(w, h);
    return parts[0] + ':' + parts[1];
  }

  function sameRatio(w, h) {
    if (!w || !h) return false;
    var a = ratioParts(w, h);
    var b = ratioParts(STD_W, STD_H);
    return a[0] === b[0] && a[1] === b[1];
  }

  function isStandard(w, h) {
    return w === STD_W && h === STD_H;
  }

  function badgeState(w, h) {
    if (!w || !h) return 'off';
    if (isStandard(w, h)) return 'ok';
    if (sameRatio(w, h)) return 'ratio';
    return 'off';
  }

  function badgeLabel(w, h) {
    if (!w || !h) return '—';
    return sizeLabel(w, h) + ' · ' + ratioLabel(w, h);
  }

  function sizeLabel(w, h) {
    if (!w || !h) return '—';
    return w + '×' + h;
  }

  function badgeClass(w, h) {
    var state = badgeState(w, h);
    if (state === 'ratio') return ' gm-ajuda-fotos-main__badge--ratio';
    if (state === 'off') return ' gm-ajuda-fotos-main__badge--off';
    return '';
  }

  function groupKey(item) {
    if (item.width && item.height) {
      return item.width + 'x' + item.height;
    }
    if (item.thumb) return 'unknown';
    return 'missing';
  }

  function buildGroups(items) {
    var map = Object.create(null);
    items.forEach(function (item) {
      var key = groupKey(item);
      if (!map[key]) {
        map[key] = {
          key: key,
          w: item.width,
          h: item.height,
          items: [],
        };
      }
      map[key].items.push(item);
    });

    return Object.keys(map)
      .map(function (key) {
        return map[key];
      })
      .sort(function (a, b) {
        if (b.items.length !== a.items.length) {
          return b.items.length - a.items.length;
        }
        var areaA = (a.w || 0) * (a.h || 0);
        var areaB = (b.w || 0) * (b.h || 0);
        return areaB - areaA;
      });
  }

  function renderCell(item) {
    var title = (item.title || '') + (item.draft ? ' · rascunho' : '');
    var label = badgeLabel(item.width, item.height);
    var badgeCls = 'gm-ajuda-fotos-main__badge' + badgeClass(item.width, item.height);
    var ratio =
      item.width && item.height
        ? item.width + ' / ' + item.height
        : '3 / 4';

    if (!item.thumb) {
      return (
        '<a class="gm-ajuda-fotos-main__cell" href="' +
        esc(item.url) +
        '" style="aspect-ratio:' +
        esc(ratio) +
        '" title="' +
        esc(title) +
        '">' +
        '<span class="gm-ajuda-fotos-main__empty">—</span>' +
        '<span class="' +
        esc(badgeCls) +
        '">' +
        esc(label) +
        '</span></a>'
      );
    }

    return (
      '<a class="gm-ajuda-fotos-main__cell" href="' +
      esc(item.url) +
      '" style="aspect-ratio:' +
      esc(ratio) +
      '" title="' +
      esc(title) +
      '">' +
      '<img src="' +
      esc(item.thumb) +
      '" alt="" width="' +
      esc(item.width || '') +
      '" height="' +
      esc(item.height || '') +
      '" loading="lazy" decoding="async">' +
      '<span class="' +
      esc(badgeCls) +
      '">' +
      esc(label) +
      '</span></a>'
    );
  }

  function renderGroup(group) {
    var head =
      group.key === 'missing'
        ? 'Sem foto · ' + group.items.length
        : group.key === 'unknown'
          ? 'Sem dimensão · ' + group.items.length
          : badgeLabel(group.w, group.h) + ' · ' + group.items.length;

    var cells = group.items
      .slice()
      .sort(function (a, b) {
        return a.handle.localeCompare(b.handle);
      })
      .map(renderCell)
      .join('');

    return (
      '<section class="gm-ajuda-fotos-main__group">' +
      '<h2 class="gm-ajuda-fotos-main__group-head">' +
      esc(head) +
      '</h2>' +
      '<div class="gm-ajuda-fotos-main__grid">' +
      cells +
      '</div></section>'
    );
  }

  function init() {
    var section = document.querySelector('.gm-ajuda-fotos-main');
    if (!section) return;

    var root = section.querySelector('[data-gm-ajuda-fotos-main-root]');
    var dataEl = section.querySelector('[data-gm-ajuda-fotos-main-data]');
    if (!root || !dataEl) return;

    var items;
    try {
      items = JSON.parse(dataEl.textContent || '[]');
    } catch (err) {
      root.innerHTML =
        '<p class="gm-ajuda-fotos-main__status">Erro ao carregar dados.</p>';
      return;
    }

    function paint(list) {
      if (!list.length) {
        root.innerHTML = '<p class="gm-ajuda-fotos-main__status">Nenhum produto.</p>';
        return;
      }
      var groups = buildGroups(list);
      root.innerHTML = groups.map(renderGroup).join('');
    }

    if (window.GmPhotoCatalog) {
      root.innerHTML = '<p class="gm-ajuda-fotos-main__status">Carregando produtos…</p>';
      window.GmPhotoCatalog.load().then(function (catalog) {
        paint(window.GmPhotoCatalog.merge(items, catalog, window.GmPhotoCatalog.mapSize));
      });
      return;
    }

    paint(items);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
